import { NavLink, useLocation } from "react-router-dom";
import { cn } from "@/utils/cn";
import { Icon } from "./icon";
import { ReactNode } from "react";

const Menu: React.FC<{
  active: boolean;
  icon: string;
  children: ReactNode;
}> = ({ active, icon, children }) => (
  <>
    <div
      className={cn(
        "ml-6 pl-16 py-2 w-[260px] rounded-full bg-black/50 text-xl transition-all duration-300 ease-in-out",
        "group-hover:scale-[1.03]",
        active && "font-bold text-2xl w-[330px] ml-9"
      )}
    >
      <span className="block transition-opacity duration-200 group-hover:opacity-90">
        {children}
      </span>
    </div>
    <div
      className={cn(
        "absolute left-0 top-0 flex items-center justify-center rounded-full bg-[#d9d9d9] transition-all duration-300 ease-in-out",
        active ? "w-20 h-20" : "w-14 h-14",
        "group-hover:scale-105"
      )}
    >
      <Icon
        name={`${icon}.png`}
        alt={icon}
        className={cn(
          "transition-transform duration-300 ease-in-out",
          active ? "w-10 h-10" : "w-8 h-8",
          "group-hover:scale-110"
        )}
      />
    </div>
  </>
);

const MenuButton: React.FC<{
  route: string;
  icon: string;
  children: string;
}> = ({ icon, route, children }) => {
  const { pathname } = useLocation();
  const active =
    route === pathname ||
    (route === "/region" &&
      (pathname === "/pheno/western" ||
        pathname === "/pheno/central" ||
        pathname === "/pheno/eastern" ||
        pathname === "/pheno/gobi")) ||
    (route === "/pheno/cities" &&
      (pathname === "/pheno/erdenet" ||
        pathname === "/pheno/darkhan" ||
        pathname === "/pheno/ulaanbaatar")) ||
    (route === "/wind/all" && pathname.startsWith("/wind")) ||
    (route === "/forecast/ulaanbaatar" && pathname.startsWith("/forecast"));

  if (route === "alert") {
    return (
      <div
        className={cn(
          "group cursor-pointer relative flex items-center text-white transition-all duration-300 ease-in-out",
          active ? "h-20 -ml-3" : "h-14"
        )}
      >
        <Menu icon={icon} active={active}>
          {children}
        </Menu>
      </div>
    );
  }
  return (
    <NavLink
      to={route}
      className={cn(
        "group cursor-pointer relative flex items-center text-white transition-all duration-300 ease-in-out",
        active ? "h-20 -ml-3" : "h-14"
      )}
    >
      <Menu icon={icon} active={active}>
        {children}
      </Menu>
    </NavLink>
  );
};

export default MenuButton;
